"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRBush = void 0;
const bbox_1 = __importDefault(require("@turf/bbox"));
const rbush_1 = __importDefault(require("rbush"));
const react_1 = require("react");
function useRBush(featureCollection) {
    const rbush = react_1.useMemo(() => {
        const rbush = new rbush_1.default();
        rbush.load(featureCollection.features
            .map(feature => {
            try {
                const [minX, minY, maxX, maxY] = bbox_1.default(feature);
                return { minX, minY, maxX, maxY, feature };
            }
            catch (e) {
                console.error(e);
                return null;
            }
        })
            .filter(function (x) {
            return !!x;
        }));
        return rbush;
    }, [featureCollection.features]);
    return rbush;
}
exports.useRBush = useRBush;
//# sourceMappingURL=useRBush.js.map